var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pi-container" }, [
    _vm.type === "nuveiCard"
      ? _c("div", { staticClass: "payment__instrument injected" }, [
          _c(
            "span",
            {
              staticClass: "piitem-arrow",
              on: {
                click: function($event) {
                  return _vm.closeDialog()
                }
              }
            },
            [_c("v-icon", [_vm._v("chevron_left")])],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "piitem-content" }, [
            _c("span", { staticClass: "piitem-picture" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaServer(
                    "/static/brand-img/" + _vm.brandKey + "/card-v2.svg"
                  ),
                  alt: "card"
                }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "piitem-text" }, [
              _c("div", { staticClass: "piitem-text-headline" }, [
                _vm._v(_vm._s(_vm.$t("Payments.Nuvei.Card.Headline")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "piitem-text-desc" }, [
                _vm._v(_vm._s(_vm.$t("Payments.Nuvei.Card.Desc")))
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "nuveiPayPal"
      ? _c("div", { staticClass: "payment__instrument injected" }, [
          _c(
            "span",
            {
              staticClass: "piitem-arrow",
              on: {
                click: function($event) {
                  return _vm.closeDialog()
                }
              }
            },
            [_c("v-icon", [_vm._v("chevron_left")])],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "piitem-content" }, [
            _c("span", { staticClass: "piitem-picture" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaServer(
                    "/static/brand-img/" + _vm.brandKey + "/paypal.svg"
                  ),
                  alt: "card"
                }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "piitem-text" }, [
              _c("div", { staticClass: "piitem-text-headline" }, [
                _vm._v(_vm._s(_vm.$t("Payments.PNM.PayPal.Headline")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "piitem-text-desc" }, [
                _vm._v(_vm._s(_vm.$t("Payments.Nuvei.PayPal.Desc")))
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "nuveiVP"
      ? _c("div", { staticClass: "payment__instrument injected" }, [
          _c(
            "span",
            {
              staticClass: "piitem-arrow",
              on: {
                click: function($event) {
                  return _vm.closeDialog()
                }
              }
            },
            [_c("v-icon", [_vm._v("chevron_left")])],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "piitem-content" }, [
            _c("span", { staticClass: "piitem-picture" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaServer(
                    "/static/brand-img/" + _vm.brandKey + "/vip-preferred.svg"
                  ),
                  alt: "vip-preferred"
                }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "piitem-text" }, [
              _c("div", { staticClass: "piitem-text-headline" }, [
                _vm._v(_vm._s(_vm.$t("Payments.Nuvei.VP.Headline")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "piitem-text-desc" }, [
                _vm._v(_vm._s(_vm.$t("Payments.Nuvei.VP.Desc")))
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "nuveiACH"
      ? _c("div", { staticClass: "payment__instrument injected" }, [
          _c(
            "span",
            {
              staticClass: "piitem-arrow",
              on: {
                click: function($event) {
                  return _vm.closeDialog()
                }
              }
            },
            [_c("v-icon", [_vm._v("chevron_left")])],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "piitem-content" }, [
            _c("span", { staticClass: "piitem-picture" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaServer(
                    "/static/brand-img/" + _vm.brandKey + "/ach-v2.svg"
                  ),
                  alt: "ach"
                }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "piitem-text" }, [
              _c("div", { staticClass: "piitem-text-headline" }, [
                _vm._v(_vm._s(_vm.$t("Payments.Nuvei.ACH.Headline")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "piitem-text-desc" }, [
                _vm._v(_vm._s(_vm.$t("Payments.Nuvei.ACH.Desc")))
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "nuveiAPay"
      ? _c("div", { staticClass: "payment__instrument injected" }, [
          _c(
            "span",
            {
              staticClass: "piitem-arrow",
              on: {
                click: function($event) {
                  return _vm.closeDialog()
                }
              }
            },
            [_c("v-icon", [_vm._v("chevron_left")])],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "piitem-content" }, [
            _c("span", { staticClass: "piitem-picture" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaServer(
                    "/static/brand-img/" + _vm.brandKey + "/apay.svg"
                  ),
                  alt: "apay"
                }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "piitem-text" }, [
              _c("div", { staticClass: "piitem-text-headline" }, [
                _vm._v(_vm._s(_vm.$t("Payments.PNM.APay.Headline")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "piitem-text-desc" }, [
                _vm._v(_vm._s(_vm.$t("Payments.PNM.APay.Desc")))
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "nuveiPNM"
      ? _c("div", { staticClass: "payment__instrument injected" }, [
          _c(
            "span",
            {
              staticClass: "piitem-arrow",
              on: {
                click: function($event) {
                  return _vm.closeDialog()
                }
              }
            },
            [_c("v-icon", [_vm._v("chevron_left")])],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "piitem-content" }, [
            _c("span", { staticClass: "piitem-picture" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaServer(
                    "/static/brand-img/" + _vm.brandKey + "/paynearme.svg"
                  ),
                  alt: "apay"
                }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "piitem-text" }, [
              _c("div", { staticClass: "piitem-text-headline" }, [
                _vm._v(_vm._s(_vm.$t("Payments.PNM.Cash.Headline")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "piitem-text-desc" }, [
                _vm._v(_vm._s(_vm.$t("Payments.Nuvei.PNM.Desc")))
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "nuveiPlayPlus"
      ? _c("div", { staticClass: "payment__instrument injected" }, [
          _c(
            "span",
            {
              staticClass: "piitem-arrow",
              on: {
                click: function($event) {
                  return _vm.closeDialog()
                }
              }
            },
            [_c("v-icon", [_vm._v("chevron_left")])],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "piitem-content" }, [
            _c("span", { staticClass: "piitem-picture" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaServer(
                    "/static/brand-img/" + _vm.brandKey + "/play-plus.svg"
                  ),
                  alt: "play-plus"
                }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "piitem-text" }, [
              _c("div", { staticClass: "piitem-text-headline" }, [
                _vm._v(_vm._s(_vm.$t("Transaction.Sightline")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "piitem-text-desc" }, [
                _vm._v(_vm._s(_vm.$t("Payments.Nuvei.PlayPlus.Desc")))
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "nuveiVenmo"
      ? _c("div", { staticClass: "payment__instrument injected" }, [
          _c(
            "span",
            {
              staticClass: "piitem-arrow",
              on: {
                click: function($event) {
                  return _vm.closeDialog()
                }
              }
            },
            [_c("v-icon", [_vm._v("chevron_left")])],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "piitem-content" }, [
            _c("span", { staticClass: "piitem-picture" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaServer(
                    "/static/brand-img/" + _vm.brandKey + "/venmo.svg"
                  ),
                  alt: "venmo"
                }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "piitem-text" }, [
              _c("div", { staticClass: "piitem-text-headline" }, [
                _vm._v(_vm._s(_vm.$t("Payments.PNM.Venmo.Headline")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "piitem-text-desc" }, [
                _vm._v(_vm._s(_vm.$t("Payments.PNM.Venmo.Desc")))
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "nuveiWd"
      ? _c("div", { staticClass: "payment__instrument injected" }, [
          _c(
            "span",
            {
              staticClass: "piitem-arrow",
              on: {
                click: function($event) {
                  return _vm.closeDialog()
                }
              }
            },
            [_c("v-icon", [_vm._v("chevron_left")])],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "piitem-content" }, [
            _c("span", { staticClass: "piitem-picture" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaServer(
                    "/static/brand-img/" + _vm.brandKey + "/cash-v2.svg"
                  ),
                  alt: "cash"
                }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "piitem-text" }, [
              _c("div", { staticClass: "piitem-text-headline" }, [
                _vm._v(_vm._s(_vm.$t("Payments.PNM.PushDebit.Headline")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "piitem-text-desc" }, [
                _vm._v(_vm._s(_vm.$t("Payments.Nuvei.Wd.Desc.Wd")))
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8319950c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8319950c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/nuvei/NuveiDialogHeader.vue
// module id = null
// module chunks = 